import { render, staticRenderFns } from "./StandardRequest.vue?vue&type=template&id=25cc4fe6"
import script from "./StandardRequest.vue?vue&type=script&lang=js"
export * from "./StandardRequest.vue?vue&type=script&lang=js"
import style0 from "./StandardRequest.vue?vue&type=style&index=0&id=25cc4fe6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports